import { begin } from '../helpers/browserTime';
import { statsFunctionGenerator } from '../statsFunctionGenerator';

export const statsFunction = statsFunctionGenerator(begin);
